import { Typography } from "@carrotfertility/carotene-core"
import React from "react"

/**
 * `.not-eligible { max-width: 560px }` — a reading measure for one sentence, wider than the booking
 * card's body because nothing sits beside it.
 */
const MAX_INLINE_SIZE = 560

/**
 * Frame 10. This *replaces* the booking card rather than merely standing in for its absence: a
 * member who cannot book still has to be told why, so `eligible && <BookAppointmentCard />` on its
 * own would leave a hole in the main column. CONAPP-270 owns choosing between the two.
 *
 * `.not-eligible` is italic `body1` in `text.secondary`, which is already `body1`'s colour in the
 * Carotene theme, so `fontStyle` is the only override. Its `margin-bottom: --space-lg` is
 * deliberately not reproduced — the page's own `Stack` spacing owns the gap to what follows.
 */
export function NotEligibleNote(): JSX.Element {
  return (
    <Typography sx={{ fontStyle: "italic", maxInlineSize: MAX_INLINE_SIZE }}>
      You are not eligible for virtual appointments at this time.
    </Typography>
  )
}
